import { ReactNode } from "react";
import styled from "styled-components";
import {
  typography,
  color,
  TypographyProps,
  ColorProps,
  space,
  SpaceProps,
} from "styled-system";

interface TableBodyProps extends ColorProps, TypographyProps, SpaceProps {
  /**
   * children elements
   */
  children: ReactNode;
  /**
   *The element's unique identifier
   */
  id?: string;
}

const Body = styled.tbody<TableBodyProps>`
  tr:last-of-type {
    border-bottom: none;
  }
  font-family: inherit;
  font-weight: inherit;

  ${color}
  ${typography}
  ${space}
`;

const TableBody = ({
  padding = 6,
  fontSize = "body",
  color = "table-body-font-color",
  backgroundColor = "table-bg-color",
  ...props
}: TableBodyProps) => (
  <Body
    padding={padding}
    fontSize={fontSize}
    color={color as string}
    backgroundColor={backgroundColor}
    {...props}
  ></Body>
);

export default TableBody;
